import {observer_mgl, RunInAction} from "mobx-graphlink";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import {Button, Column, Row} from "react-vcomponents";
import React from "react";
import {E} from "js-vextensions";
import {store} from "../../../../Store/index.js";
import {MapTool} from "./Tools/@Tool.js";
import {DMap} from "../../../../Server/DB/maps/@Map.js";

export const ToolboxUI = observer_mgl(({map, mapState}: {map: DMap, mapState: MapState})=>{
	return (
		<Column style={{position: "absolute", zIndex: 1, left: 0, top: 25, padding: 5}}>
			{/*<ToolButton mt={0} {...{map, mapState}} icon="circle-small" tool={MapTool.none}/>*/}
			<ToolButton mt={0} {...{map, mapState}} icon="pan" tool={MapTool.pan}/>
			<ToolButton mt={5} {...{map, mapState}} icon="selection-drag" tool={MapTool.select}/>
			<ToolButton mt={5} {...{map, mapState}} icon="ruler" tool={MapTool.measure}/>
			<ToolButton mt={5} {...{map, mapState}} icon="crosshairs" tool={MapTool.cursor}/>
			<ToolButton mt={5} {...{map, mapState}} icon="plus-thick" tool={MapTool.addObject}/>
			<ToolButton mt={5} {...{map, mapState}} icon="cursor-move" tool={MapTool.move}/>
			<ToolButton mt={5} {...{map, mapState}} icon="move-resize-variant" tool={MapTool.resize}/>
			<ToolButton mt={5} {...{map, mapState}} icon="vector-polyline-plus" tool={MapTool.meshModify}/>
			<ToolButton mt={5} {...{map, mapState}} icon="road-variant" tool={MapTool.pathModify}/>
		</Column>
	);
});

const ToolButton = observer_mgl(({mt, map, mapState, tool, icon}: {mt: number, map: DMap, mapState: MapState, tool: MapTool, icon: string})=>{
	const uiState = store.main.maps.tools;
	return (
		<Button mt={mt} size={32} mdIcon={icon} title={tool}
			style={E(
				uiState.activeTool == tool && {backgroundColor: "hsl(0,0%,50%)"},
			)}
			onClick={()=>RunInAction("ToolButton.onClick", ()=>{
				const oldActive = uiState.ActiveTool();
				if (oldActive != null) oldActive.Tool_OnDeactivate?.({map, mapState});
				uiState.activeTool = tool;
				const newActive = uiState.ActiveTool();
				if (newActive != null) newActive.Tool_OnActivate?.({map, mapState});
			})}/>
	);
});